import React, {useContext, useEffect, useState} from "react";
import {Button, ButtonGroup, Banner} from "@shopify/polaris";
import axios from "../axios";
import {createApp} from "@shopify/app-bridge";
import {Redirect} from "@shopify/app-bridge/actions";
import {ShopContext} from "../App";
import _ from "lodash";
import Br from "./Br";

const AppSubscribeBanner = ({
                                hasActiveSubscription,
                                setHasActiveSubscription,
                                setLoadingSubscription,
                                show = false
                            }) => {
    const config = useContext(ShopContext);
    const [loading, setLoading] = useState(false);
    const subscribeForBilling = () => {
        setLoading(true);
        setLoadingSubscription(true);
        axios.get(`/billing/recurring`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            if (response.success) {
                const app = createApp({
                    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
                    host: config.host
                });
                Redirect.create(app).dispatch(Redirect.Action.REMOTE, response.conformation_url);
            }
            setLoading(false);
            setLoadingSubscription(false);
        }).catch((error) => {
            setLoading(false);
            setLoadingSubscription(false);
        });
    }
    useEffect(() => {
        setLoading(true);
        axios.get(`/billing/details`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            let hasSubscription = _.get(response, 'details.has_active_subscription', false);
            setHasActiveSubscription(hasSubscription);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
    }, [config, setHasActiveSubscription])
    if (hasActiveSubscription && !show) {
        return null
    }
    return (
        <Banner
            status='info'
            title='Upgrade notice'
        >
            <p>Please upgrade your plan to <b>Starter</b> to start using automation messages.</p>
            <Br height={10}/>
            <ButtonGroup>
                {!hasActiveSubscription &&
                <Button primary onClick={subscribeForBilling} disabled={(loading || hasActiveSubscription)}
                        loading={loading}>{hasActiveSubscription ? 'Subscribed' : 'Upgrade'}</Button>}
            </ButtonGroup>
        </Banner>
    );
}
export default AppSubscribeBanner;
